<template>
    <div class="info">
        <div class="table-wrap">
            <div class="headtable-top">
                <p><span class="c-red">*</span> 표시는 필수 입력 항목입니다.</p>
            </div>
            <div class="table headtable baby-info table-input">
                <table>
                    <colgroup>
                        <col style="width:25%;">
                        <col style="width:25%;">
                        <col style="width:25%;">
                        <col style="width:25%;">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th><h4 class="title03"><span class="c-red">*</span> 출산일</h4></th>
                            <td>
                                <VueDatePicker
                                    v-model="params.birthDay"
                                    locale="ko"
                                    :format="formatDate"
                                    :enable-time-picker="false"
                                    week-start="0"
                                    position="left"
                                    placeholder="날짜를 선택하세요."
                                    auto-apply
                                />
                            </td>
                            <th><h4 class="title03"><span class="c-red">*</span> 시간</h4></th>
                            <td>
                                <div class="headtable-time">
                                    <div class="headtable-time__item">
                                        <a href="javascript:;" class="top" @click="addHour('hour', 1)"></a>
                                        <input type="text" maxlength="2" value="00" v-model="params.hour" @input="params.hour = params.hour > 24 ? 24 : params.hour < 0 ? 0 : params.hour"/>
                                        <a href="javascript:;" class="bottom" @click="addHour('hour', -1)"></a>
                                    </div>
                                    <div class="headtable-time__item">
                                        <p>:</p>
                                    </div>
                                    <div class="headtable-time__item">
                                        <a href="javascript:;" class="top" @click="addMinute('minute', 1)"></a>
                                        <input type="text" maxlength="2" value="00" v-model="params.minute" @input="params.minute = params.minute > 59 ? 59 : params.minute < 0 ? 0 : params.minute"/>
                                        <a href="javascript:;" class="bottom" @click="addMinute('minute', -1)"></a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th><h4 class="title03"><span class="c-red">*</span> 아기 이름</h4></th>
                            <td>
                                <input type="text" class="head-symptom__input" v-model="params.babyName" maxlength="10">
                            </td>
                            <th rowspan="3">
                                <h4 class="title03">아기사진등록</h4>
                            </th>
                            <td rowspan="3">
                                <div class="baby-photo">
                                    <p>(이미지 비율 1:1)</p>
                                    <input type="file" name="babyInput" class="babyInput" accept="image/*" @change="changeFile" hidden ref="file">
                                    <a href="javascript:;" class="baby-photo__btn mt10" @click="selectFile">
                                        <img src="" alt="" name="babyImg" style="display: none;">
                                    </a>
                                    <div class="baby-photo__name" v-if="fileName">
                                        <p>{{fileName}}</p>
                                        <a href="javascript:;" class="baby-photo--close" @click="deleteFile"></a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th><h4 class="title03"><span class="c-red">*</span> 아기 태명</h4></th>
                            <td>
                                <input type="text" class="head-symptom__input" v-model="params.babyBirthName" maxlength="10">
                            </td>
                        </tr>
                        <tr>
                            <th><h4 class="title03"><span class="c-red">*</span> 아기 성별</h4></th>
                            <td>
                                <div class="botton-wrap">
                                    <a href="javascript:;" :class="{'sub-button small c-sub': true, 'active': params.gender == 'M'}" @click="params.gender = 'M'">남자</a>
                                    <a href="javascript:;" :class="{'sub-button small c-main': true, 'active': params.gender == 'F'}" @click="params.gender = 'F'">여자</a>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th><h4 class="title03">신장</h4></th>
                            <td>
                                <div class="baby-weight">
                                    <input type="text" class="head-symptom__input" v-model="params.height" @input="this.$commonUtils.numberPeriodOnly" maxlength="5"><p>cm</p>
                                </div>
                            </td>
                            <th><h4 class="title03">체중</h4></th>
                            <td>
                                <div class="baby-weight">
                                    <input type="text" class="head-symptom__input" v-model="params.weight" @input="this.$commonUtils.numberPeriodOnly" maxlength="5"><p>kg</p>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th><h4 class="title03">머리둘레</h4></th>
                            <td>
                                <div class="baby-weight">
                                    <input type="text" class="head-symptom__input" v-model="params.headSize" @input="this.$commonUtils.numberPeriodOnly"><p>cm</p>
                                </div>
                            </td>
                            <th><h4 class="title03">분만방법</h4></th>
                            <td colspan="3">
                                <div class="radio-wrap">
                                    <label for="progress01">
                                        <input type="radio" name="progress01" id="progress01" value="자연분만" v-model="params.progress">
                                        <span class="radio-btn"></span><p>자연분만</p>
                                    </label>
                                    <label for="progress02">
                                        <input type="radio" name="progress02" id="progress02" value="제왕절개" v-model="params.progress">
                                        <span class="radio-btn"></span><p>제왕절개</p>
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th><h4 class="title03">메모</h4></th>
                            <td colspan="3" class="left">
                                <textarea name="" id="" placeholder="자유롭게 작성해주세요." v-model="params.memo" maxlength="500"></textarea>
                            </td>
                        </tr>
                        <tr>
                            <th><h4 class="title03">담당의</h4></th>
                            <td colspan="3" class="left">
                                <div class="table-input__box">
                                    <h4 class="input-title">의료진</h4>
                                    <div class="table-input__medical">
                                        <!-- :disabled="viewDrName.length > 0" -->
                                        <input type="text" placeholder="의료진을 검색해주세요." @keyup.enter="$refs.searchDoc.popupBtn" @click="$refs.searchDoc.popupBtn" readonly>
                                        <input type="text" placeholder="검색창에서 입력하신 의료진이 표시됩니다." v-model="viewDrName" readonly>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="botton-wrap nowrap">
            <a href="javascript:;" class="sub-button c-gray" @click="cancelRecord">취소</a>
            <a href="javascript:;" class="main-button c-main" @click="saveSubmit">{{mbSn ? '수정' : '등록'}}</a>
        </div>
    </div>

    <kr_popup_searchDoctor ref="searchDoc" @setParams="setParams"></kr_popup_searchDoctor>
    <kr_popup_health ref="MypagePopupVue"/>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
    components: {
        VueDatePicker,
    },
    data() {
        return {
            showStartDate: null, // 초기값 설정
            formatDate: 'yyyy-MM-dd', // 원하는 날짜 형식 설정

            params: {
                birthDay: null,
                hour: '00',
                minute: '00',
            },
            fileName: '',

            mbSn: this.$route.query.mbSn || '',
        };
    },
    methods: {
        deleteFile(){
            document.querySelector('input[name=babyInput]').value = ''
            document.querySelector('img[name=babyImg]').setAttribute('src', '')
            document.querySelector('img[name=babyImg]').style.display = 'none'
            this.fileName = ''
            this.params.attachBag = ''
        },
        selectFile(){
            document.querySelector('input[name=babyInput]').click()
        },
        changeFile(event){
            const file = event.target.files[0]
            if(file){
                this.fileName = this.$refs.file.files[0].name
                const img = document.querySelector('img[name=babyImg]')
                const reader = new FileReader()
                reader.onload = (e) => {
                    const imgUrl = e.target.result
                    img.setAttribute('src', imgUrl)
                    img.style.display = 'block'
                }
                reader.readAsDataURL(file)
            }
        },
        saveSubmit() {
            console.log(this.params)
            if(!this.params.birthDay){
                alert('출산일을 입력해주세요.')
                return
            }
            if(!this.params.babyName){
                alert('아기 이름을 입력해주세요.')
                return
            }
            if(!this.params.babyBirthName){
                alert('아기 태명을 입력해주세요.')
                return
            }
            if(!this.params.gender){
                alert('아기 성별을 선택택해주세요.')
                return
            }
            
            this.$refs.MypagePopupVue.popupBtn()
        },
        submit(){
            if(!this.params.birthDay){
                alert('출산일을 입력해주세요.')
                return
            }
            if(!this.params.babyName){
                alert('아기 이름을 입력해주세요.')
                return
            }
            if(!this.params.babyBirthName){
                alert('아기 태명을 입력해주세요.')
                return
            }
            if(!this.params.gender){
                alert('아기 성별을 선택택해주세요.')
                return
            }

            const year = this.params.birthDay.getFullYear()
            const month = ('0' + (this.params.birthDay.getMonth() + 1)).slice(-2)
            const day = ('0' + this.params.birthDay.getDate()).slice(-2)

            const data = new FormData();
            data.append('birthDt', year + '' + month + '' + day + this.params.hour + this.params.minute + '00');
            data.append('babyName', this.params.babyName);
            data.append('babyBirthName', this.params.babyBirthName);
            data.append('gender', this.params.gender);
            data.append('weight', this.params.weight ? this.params.weight : '');
            data.append('height', this.params.height ? this.params.height : '');
            data.append('headSize', this.params.headSize ? this.params.headSize : '');
            data.append('childBirthProgress', this.params.childbirthTime ? this.params.childbirthTime : '');
            data.append('childBirthProgress', this.params.childBirthProgress ? this.params.childBirthProgress : '');
            data.append('memo', this.params.memo ? this.params.memo : '');
            for(let i of Object.keys(this.params)){
                if(i == 'refDoctorList') data.append('refDoctorList', JSON.stringify(this.params['refDoctorList']) );
            }

            if(this.params.attachBag){
                data.append('attachBag', this.params.attachBag);
            }else{
                let list = []
                const file = document.querySelector('input[name=babyInput]').files[0]
                if(file){
                    const obj = {};
                    obj.hospId = null;
                    obj.refKey = null;
                    obj.refType = 'birthRecord';
                    obj.refMapCode = 'attach';
                    obj.attachNo = null;
                    obj.savedName = null;
                    obj.savedDir = null;
                    obj.fileType = null;
                    obj.altValue = '';
                    obj.displayName = file.name;
                    obj.fileSize = String(file.size);
                    
                    data.append('uploader', file);
                    list.push(obj)
                    
                    data.append('attachBag', JSON.stringify(list));
                }
            }

            let url = this.api.mypage.recordReg
            if(this.mbSn){
                url = this.api.mypage.recordUpdate
                data.append('mbSn', this.mbSn);
            }

            this.axios({
                method: "post",
                url: url,
                headers: { 'Content-type': 'multipart/form-data' },
                data: data
            })
            .then(res => {
                alert('저장되었습니다.')
                this.$router.push('/kr/mypage/babyNote/birthRecord')
            })
        },
        cancelRecord(){
            if(confirm('화면 이동시 작성 중인 내용은 사라집니다. 이동하시겠습니까까?')){
                this.$router.push('/kr/mypage/babyNote/birthRecord')
            }
        },
        addHour(target, num) {
            let temp = parseInt(this.params[target]) + num
            if(temp < 0){
                temp = 0
            }else if(temp > 23){
                temp = 23
            }

            this.params[target] = temp.toString().length < 2 ? `0${temp}` : temp
        },
        addMinute(target, num) {
            let temp = parseInt(this.params[target]) + num
            if(temp < 0){
                temp = 0
            }else if(temp > 59){
                temp = 59
            }
            this.params[target] = temp.toString().length < 2 ? `0${temp}` : temp
        },
        setParams(param){
            Object.assign(this.params, param)
        },
        getDetail(){
            this.axios.get(this.api.mypage.recordDetail, {
                params: { mbSn: this.mbSn }
            })
            .then(res => {
                if(!res.data){
                    alert('이미 삭제된 데이터입니다.')
                    this.$router.go(-1)
                    return
                }
                const data = res.data
                const date = new Date(data.birthDt)
                const year = date.getFullYear()
                const month = ('0' + (date.getMonth() + 1)).slice(-2)
                const day = ('0' + date.getDate()).slice(-2)
                const hour = ('0' + date.getHours()).slice(-2)
                const minute = ('0' + date.getMinutes()).slice(-2)
                // this.params.birthDay = `${year}-${month}-${day}`
                this.params.birthDay = date
                this.params.hour = hour
                this.params.minute = minute
                this.params.babyName = data.babyName
                this.params.babyBirthName = data.babyBirthName
                this.params.gender = data.gender
                this.params.weight = data.weight
                this.params.height = data.height
                this.params.headSize = data.headSize
                this.params.progress = data.childBirthProgress
                this.params.memo = data.memo
                if(data.refDoctorList){
                    for(let i of data.refDoctorList){
                        i.mainDeptCd = i.mainDeptCd ? i.mainDeptCd : i.deptCd
                        this.$refs.searchDoc.setDoctor(i)
                    }
                }
                if(data.attachBag.attach){
                    const attach = data.attachBag.attach[0]
                    this.fileName = attach.displayName

                    document.querySelector('img[name=babyImg]').setAttribute('src', `/displayFile.do?attachNo=${attach.attachNo}`)
                    document.querySelector('img[name=babyImg]').style.display = 'block'

                    let list = []
                    const obj = {};
                    obj.hospId = attach.hospId;
                    obj.refKey = attach.refKey;
                    obj.refType = attach.refType;
                    obj.refMapCode = attach.refMapCode;
                    obj.attachNo = attach.attachNo;
                    obj.savedName = attach.savedName;
                    obj.savedDir = null;
                    obj.fileType = attach.fileType;
                    obj.altValue = attach.altValue;
                    obj.displayName = attach.name;
                    obj.fileSize = String(attach.fileSize);

                    list.push(obj)

                    this.params.attachBag = JSON.stringify(list);
                }
                console.log(this.params)
            })
        }
    },
    mounted() { 
        if(this.mbSn){
            this.getDetail()
        }
    },
    computed: {
        viewDrName: {
            get() {
                if (this.params.refDoctorList && Array.isArray(this.params.refDoctorList)) {
                    return this.params.refDoctorList.map(i => i.name).join(', ')
                }
                return ''
            }
        }
    }
};
</script>
<style scoped></style>